import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.values.js";
import dayjs from 'dayjs';
import m3u8Video from '@/components/m3u8Video';
export default {
  components: {
    m3u8Video: m3u8Video
  },
  data: function data() {
    return {
      dayjs: dayjs,
      labList: [],
      videoName: '',
      videoList: [],
      videoId: '',
      show: false
    };
  },
  mounted: function mounted() {
    this.getVideoList();
  },
  methods: {
    getVideoList: function getVideoList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, data, _iterator, _step, item;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$api['videoQuery']({
                page: 1,
                limit: -1,
                videoName: _this.videoName,
                labId: localStorage.getItem('labId') || '',
                sortField: 'lab_id,^sort'
              });
            case 2:
              res = _context.sent;
              data = {};
              _iterator = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  if (data[item.labId]) {
                    data[item.labId].videoList.push(item);
                  } else {
                    data[item.labId] = {
                      labId: item.labId,
                      labName: item.labName,
                      videoList: [item]
                    };
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _this.labList = Object.values(data);
              console.log('this.labList', _this.labList);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openClick: function openClick(index) {
      this.$set(this.labList[index], 'open', !this.labList[index].open);
    },
    videoClick: function videoClick(index, idx) {
      var data = this.labList[index].videoList[idx];
      this.$set(this.labList[index].videoList[idx], 'active', !data.active);
      if (this.labList[index].videoList[idx].active) {
        this.videoList.unshift(data);
      } else {
        for (var i in this.videoList) {
          if (this.videoList[i].id === data.id) {
            this.videoList.splice(i, 1);
            break;
          }
        }
      }
      this.videoList = this.videoList.slice(0, 6);
    },
    backClick: function backClick() {
      this.$router.back();
    }
  }
};